module.exports = __webpack_public_path__ + "media/images/icons/flags/DS-e731d85db4daa89a5fec9e3e59492418.svg";